module.exports = __webpack_public_path__ + "static/img/expressCode.46c4d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payResult/expressCode.png
// module id = B9F3
// module chunks = 0